import { render, staticRenderFns } from "./ruhani.vue?vue&type=template&id=b478b4b6&scoped=true&"
import script from "./ruhani.vue?vue&type=script&lang=js&"
export * from "./ruhani.vue?vue&type=script&lang=js&"
import style0 from "./ruhani.vue?vue&type=style&index=0&id=b478b4b6&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b478b4b6",
  null
  
)

export default component.exports